import { api, type ApiResponse } from '../utils';
import type {
  UpdateProfileData,
  UpdateAvatarData,
  DeleteAvatarData,
  UploadAvatarData,
  FetchStreamData,
  UpdatePasswordData,
  CreateMessageTemplateData,
  UpdateMessageTemplateData,
  UpdateAiSummaryData,
} from '../types/profile';

export const getProfile = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/profile/get-profile');
  return response;
};

export const updateProfile = async (
  data: UpdateProfileData
): Promise<ApiResponse> => {
  const { data: response } = await api.patch('/profile/update-profile', data);
  return response;
};

export const uploadAvatar = async (
  data: UploadAvatarData
): Promise<ApiResponse> => {
  const formData = new FormData();
  formData.append('file', data);

  const { data: response } = await api.post(
    '/profile/upload-avatar',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response;
};

export const updateAvatar = async (
  data: UpdateAvatarData
): Promise<ApiResponse> => {
  const { data: response } = await api.patch('/profile/update-avatar', data);
  return response;
};

export const deleteAvatar = async (
  data: DeleteAvatarData
): Promise<ApiResponse> => {
  const { data: response } = await api.delete(
    `/profile/delete-avatar?url=${data.url}`
  );
  return response;
};

export const updatePassword = async (
  data: UpdatePasswordData
): Promise<ApiResponse> => {
  const { data: response } = await api.post('/auth/update-password', data);
  return response;
};

export const getAiSummary = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/profile/get-summary');
  return response;
};

export const updateAiSummary = async (
  data: UpdateAiSummaryData
): Promise<ApiResponse> => {
  const { data: response } = await api.patch(`/profile/update-summary/${data.id}`, {
    summary: data.summary,
  });
  return response;
};

export const createMessageTemplate = async (
  data: CreateMessageTemplateData
): Promise<ApiResponse> => {
  const { data: response } = await api.post('/message-templates/create', data);
  return response;
};

export const updateMessageTemplate = async (
  data: UpdateMessageTemplateData
): Promise<ApiResponse> => {
  const payload = {
    title: data.title,
    body: data.body,
    is_active: true,
  };

  const { data: response } = await api.patch(
    `/message-templates/update/${data.id}`,
    payload
  );
  return response;
};

export const getMessageTemplates = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/message-templates/get-All');
  return response;
};

export const fetchStream = async (data: FetchStreamData) => {
  try {
    // Using fetch to get the stream file
    const response: any = await fetch(
      `${import.meta.env.VITE_API_BACKEND_BASE_URL}/profile/stream-file?url=${data.url}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
        },
      }
    );
    const responseData = await response.blob();
    const objectUrl = URL.createObjectURL(responseData);

    return objectUrl;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to fetch stream',
      result: null,
    };
  }
};
